<div class="relative">
  <div
    class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none"
  >
    <img src="/public/images/searchicon.svg" alt="searchicon" />
  </div>
  <input
    type="text"
    placeholder="Search"
    class="bg-e-white-text pl-10 pr-2 py-2 border-2 border-e-support-11 rounded-lg"
    [(ngModel)]="search"
    (ngModelChange)="searchData($event)"
  />
</div>
